var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "searchIcon",
    viewBox: "0 0 21.1 21.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    d: "M169.15,196.25l-5.25-5.2a7.94,7.94,0,0,0,1.35-4.55,8.62,8.62,0,0,0-8.6-8.6h-0.2a8.59,8.59,0,0,0-6,14.55l0.1,0.1a8.22,8.22,0,0,0,6.1,2.55,7,7,0,0,0,1.7-.2,7.77,7.77,0,0,0,2.7-1l5.2,5.2,2.9-2.85m-5.55-9.75a6.5,6.5,0,0,1-1.05,3.65,11.73,11.73,0,0,1-1,1.25,6.85,6.85,0,0,1-3.55,2,8.87,8.87,0,0,1-1.35.1A7,7,0,1,1,163.6,186.5Z",
    transform: "translate(-148.05 -177.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.63d8bd0e.svg";
export { ForwardRef as ReactComponent };